<template>
  <div>
    <com-table ref="table" :defaultParams="defaultParams" :columns="columns" :api="api">
      <template #createTime="row">
        {{ row.data.createTime | timeFormate }}
      </template>
      <template #payType="row">
        {{ row.data.status === '2' ? '已支付' : '未支付' }}
      </template>
      <template #rechargeType="{ data }">
        {{ data.type === 'WALLET' ? '钱包支付' : '代充值' }}
      </template>
    </com-table>
  </div>
</template>

<script>
import { rechargeListApi } from '@/api/order'

export default {
  props: {
    typeOfView: {
      type: String,
      default: 'all'
    },
    userCode: {
      type: String,
      default: ''
    },
    requireApi: {
      type: Function,
      default: null
    },
    query: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    userCode: {
      handler(val) {
        if (val) {
          this.defaultParams.refUser = val
        }
      },
      deep: true,
      immediate: true
    },
    typeOfView: {
      handler(val) {
        if (val === 'user') {
          console.log('typeOfView :>> ', val)
          this.columns.splice(3, 2)
          this.columns.pop()
          const newItem = {
            label: '赠送金额',
            prop: 'giveSum'
          }
          this.columns.splice(4, 0, newItem)
        }
        if (val === 'partner') {
          const newItem = {
            label: '合伙人分成',
            prop: '',
            width: 100
          }
          this.columns.splice(4, 0, newItem)
        }

        if (val === 'rechargeOrder') {
          const newItem = {
            label: '支付状态',
            prop: '',
            width: 100,
            type: 'slot',
            slotName: 'payType'
          }
          this.columns.splice(6, 0, newItem)
        }
      },
      deep: true,
      immediate: true
    },
    requireApi: {
      handler(val) {
        if (val) {
          this.defaultParams.code = this.userCode
          delete this.defaultParams.refUser
          this.api = val
        }
      },
      immediate: true,
      deep: true
    },
    query: {
      handler(val) {
        if (val) {
          this.defaultParams = { ...val }
          setTimeout(() => {
            this.$refs.table.init()
            console.log('val---- :>> ', this.defaultParams)
          }, 50)
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      api: rechargeListApi,
      defaultParams: {
        status: ''
      },
      columns: [
        {
          label: '订单编号',
          prop: 'number',
          width: 170
        },
        {
          label: '流水号',
          prop: 'transactionId',
          width: 280
        },
        {
          label: '网点名称',
          prop: 'storeName',
          width: 200
        },
        {
          label: '用户ID',
          prop: 'refUserNumber',
          minWidth: 180
        },
        {
          label: '手机号',
          prop: 'refUserPhone',
          minWidth: 150
        },
        {
          label: '充值金额',
          prop: 'paySum'
        },
        {
          label: '充值类型',
          prop: 'rechargeType',
          type: 'slot',
          slotName: 'rechargeType',
          width: 120
        },
        {
          label: '电卡号',
          prop: 'cardNo',
          width: 120
        },
        {
          label: '充值方式',
          prop: 'payType',
          width: 120
        },
        {
          label: '充值时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          width: '180'
        }
      ]
    }
  },
  methods: {
    handleRefund(row) {
      console.log('row :>> ', row)
      this.$message.info('暂未开发')
    },
    search(val) {
      this.$refs.table.search(val)
    }
  }
}
</script>
